// extracted by mini-css-extract-plugin
module.exports = {"module":"Icon_module__3ixci","inFlow":"Icon_inFlow__3jvIH","notClickable":"Icon_notClickable__3aO7h"};